import * as types from './types';

export const setSchoolDashboardLoading = (isLoading) => ({
  type: types.SCHOOL_DASHBOARD_SET_LOADING,
  isLoading
});

export const getSchoolDashboardData = (schoolId, maxRecentlyViewedApplicationsCount) => ({
  type: types.SCHOOL_DASHBOARD_GET_DATA,
  schoolId,
  maxRecentlyViewedApplicationsCount
});

export const setSchoolDashboardData = (data) => ({
  type: types.SCHOOL_DASHBOARD_SET_DATA,
  data
});

export const resetSchoolDashboardData = () => ({
  type: types.SCHOOL_DASHBOARD_RESET_DATA
});



// WEBPACK FOOTER //
// ./src/actions/school-dashboard/index.js